/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    EVMChain,
    EVMChainFromJSON,
    EVMChainFromJSONTyped,
    EVMChainToJSON,
} from './';

/**
 * 
 * @export
 * @interface AddNftTrackerBody
 */
export interface AddNftTrackerBody {
    /**
     * 
     * @type {string}
     * @memberof AddNftTrackerBody
     */
    grouping: string;
    /**
     * 
     * @type {string}
     * @memberof AddNftTrackerBody
     */
    contractAddress: string;
    /**
     * 
     * @type {EVMChain}
     * @memberof AddNftTrackerBody
     */
    evmChain: EVMChain;
    /**
     * 
     * @type {string}
     * @memberof AddNftTrackerBody
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AddNftTrackerBody
     */
    openSea?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AddNftTrackerBody
     */
    isIneligibleForLeaderboards?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AddNftTrackerBody
     */
    maxLimitMint?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AddNftTrackerBody
     */
    useThirdwebEngine?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AddNftTrackerBody
     */
    relayerUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof AddNftTrackerBody
     */
    forwarderAddress?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AddNftTrackerBody
     */
    mintVirtually?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AddNftTrackerBody
     */
    mintImage?: string;
}

export function AddNftTrackerBodyFromJSON(json: any): AddNftTrackerBody {
    return AddNftTrackerBodyFromJSONTyped(json, false);
}

export function AddNftTrackerBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddNftTrackerBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'grouping': json['grouping'],
        'contractAddress': json['contractAddress'],
        'evmChain': EVMChainFromJSON(json['evmChain']),
        'name': json['name'],
        'openSea': !exists(json, 'openSea') ? undefined : json['openSea'],
        'isIneligibleForLeaderboards': !exists(json, 'isIneligibleForLeaderboards') ? undefined : json['isIneligibleForLeaderboards'],
        'maxLimitMint': !exists(json, 'maxLimitMint') ? undefined : json['maxLimitMint'],
        'useThirdwebEngine': !exists(json, 'useThirdwebEngine') ? undefined : json['useThirdwebEngine'],
        'relayerUrl': !exists(json, 'relayerUrl') ? undefined : json['relayerUrl'],
        'forwarderAddress': !exists(json, 'forwarderAddress') ? undefined : json['forwarderAddress'],
        'mintVirtually': !exists(json, 'mintVirtually') ? undefined : json['mintVirtually'],
        'mintImage': !exists(json, 'mintImage') ? undefined : json['mintImage'],
    };
}

export function AddNftTrackerBodyToJSON(value?: AddNftTrackerBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'grouping': value.grouping,
        'contractAddress': value.contractAddress,
        'evmChain': EVMChainToJSON(value.evmChain),
        'name': value.name,
        'openSea': value.openSea,
        'isIneligibleForLeaderboards': value.isIneligibleForLeaderboards,
        'maxLimitMint': value.maxLimitMint,
        'useThirdwebEngine': value.useThirdwebEngine,
        'relayerUrl': value.relayerUrl,
        'forwarderAddress': value.forwarderAddress,
        'mintVirtually': value.mintVirtually,
        'mintImage': value.mintImage,
    };
}


